var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7509 10.1941C18.7509 9.47471 18.6913 8.94971 18.5624 8.40527H10.1794V11.6525H15.1C15.0009 12.4594 14.4652 13.6747 13.2747 14.4913L13.258 14.6L15.9085 16.6123L16.0921 16.6303C17.7786 15.1039 18.7509 12.858 18.7509 10.1941Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1783 18.75C12.589 18.75 14.6128 17.9722 16.091 16.6305L13.2735 14.4916C12.5196 15.0068 11.5077 15.3666 10.1783 15.3666C7.81724 15.3666 5.8133 13.8402 5.09895 11.7305L4.99424 11.7392L2.23819 13.8295L2.20215 13.9277C3.67038 16.786 6.68625 18.75 10.1783 18.75Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10038 11.7307C4.9119 11.1863 4.80281 10.6029 4.80281 10.0002C4.80281 9.39735 4.9119 8.81403 5.09047 8.2696L5.08548 8.15365L2.29488 6.02979L2.20358 6.07235C1.59845 7.25847 1.25122 8.59044 1.25122 10.0002C1.25122 11.4099 1.59845 12.7418 2.20358 13.9279L5.10038 11.7307Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1784 4.63331C11.8549 4.63331 12.9859 5.34303 13.6307 5.93613L16.1506 3.525C14.603 2.11528 12.5891 1.25 10.1784 1.25C6.68628 1.25 3.67039 3.21387 2.20215 6.07218L5.08905 8.26944C5.81332 6.15972 7.81727 4.63331 10.1784 4.63331Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaGoogle);
export default __webpack_public_path__ + "static/media/social_media_google.7241168af369a14f245817166bead79b.svg";
export { ForwardRef as ReactComponent };